<!-- TEST: Validación de ngx-translate (TEMPORAL - REMOVER DESPUÉS) -->
<!-- <div style="position: fixed; top: 10px; right: 10px; background: #4CAF50; color: white; padding: 10px; border-radius: 5px; z-index: 9999; font-size: 14px;">
🌐 Traducción: {{ 'test.welcome' | translate }} - {{ 'test.hello' | translate }}
</div> -->

<ngx-spinner type="ball-scale-multiple"> <p style="font-size: 20px; color: white">Espere...</p> </ngx-spinner>
<router-outlet></router-outlet>
<!-- Modal de validación de PIN para refresh token -->
<app-pin-validation-modal></app-pin-validation-modal>
<!-- Chatbot RAG global -->
@if (chatbotEnabled && !router.url.startsWith('/asistente')) {
  <app-chat-widget></app-chat-widget>
}
